/**
 * แปลง level_code ที่ยาว เช่น "ม.ต้น", "ม.ปลาย" → "ม."
 * เพื่อให้แสดง ม.1/1 แทน ม.ต้น.1/1
 */
export function levelCodePrefix(level_code) {
  if (!level_code) return '';
  // ถ้าขึ้นต้นด้วย ม (ม.ต้น, ม.ปลาย, ม, มัธยม ฯลฯ) → ใช้ ม.
  if (/^ม/i.test(level_code) || /junior|middle|senior|high/i.test(level_code)) return 'ม.';
  // ถ้าขึ้นต้นด้วย อ → อ.
  if (/^อ/i.test(level_code) || /kindergarten/i.test(level_code)) return 'อ.';
  // ถ้าขึ้นต้นด้วย ป → ป.
  if (/^ป/i.test(level_code) || /primary/i.test(level_code)) return 'ป.';
  return level_code + '.';
}

/**
 * สร้าง label ห้องเรียน เช่น ม.1/1, ป.3/2, อ.2/1
 */
export function classroomLabel(c) {
  if (!c) return '';
  return `${levelCodePrefix(c.level_code)}${c.grade}/${c.room}`;
}
